import React from 'react';
import ReusableTabs from '../../../pages/ReusableTabs';
import LibrarySection from './LibrarySection';

const OpenForAllPanel = () => {
  const tabs = [
    
    { label: 'Quality', component: <LibrarySection department="quality" /> },
    { label: 'Engineering', component:<LibrarySection department = "engineering" />},
    
  ];

  return (
    <div>
      <ReusableTabs
        tabs={tabs}
        defaultTab={0}
        panelStyles={{ padding: '16px' }}
      />
      
    </div>
  );
};

export default OpenForAllPanel;